// ============================================
// LOGIN ADMIN
// src/pages/admin/LoginAdmin.tsx
// ============================================

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAdminAuth } from '../../contexts/AdminAuthContext';

export function LoginAdmin() {
  const [usuario, setUsuario] = useState('');
  const [senha, setSenha] = useState('');
  const [mostrarSenha, setMostrarSenha] = useState(false);
  const { login, loading, erro, isAuthenticated, limparErro } = useAdminAuth();
  const navigate = useNavigate();

  // Redirecionar se já estiver autenticado
  useEffect(() => {
    if (isAuthenticated()) {
      navigate('/admin/dashboard');
    }
  }, [isAuthenticated, navigate]);

  // Limpar erro ao digitar
  useEffect(() => {
    if (erro) {
      limparErro();
    }
  }, [usuario, senha]);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();

    if (!usuario.trim() || !senha.trim()) {
      return;
    }

    const sucesso = await login(usuario.trim(), senha);
    
    if (sucesso) {
      navigate('/admin/dashboard');
    }
  }

  return (
    <div 
      className="d-flex align-items-center justify-content-center"
      style={{ 
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 50%, #667eea 100%)'
      }}
    >
      <div className="card shadow-lg" style={{ width: '100%', maxWidth: '420px', margin: '20px' }}>
        {/* Header */}
        <div 
          className="card-header text-center py-4"
          style={{ 
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            borderBottom: 'none'
          }}
        >
          <div className="mb-3">
            <i className="fas fa-shield-alt fa-3x text-white"></i>
          </div>
          <h3 className="text-white mb-1">Área Administrativa</h3>
          <p className="text-white-50 mb-0 small">
            Sistema de Gestão Sophya
          </p>
        </div>

        {/* Body */}
        <div className="card-body p-4">
          {/* Alerta de erro */}
          {erro && (
            <div className="alert alert-danger d-flex align-items-center" role="alert">
              <i className="fas fa-exclamation-circle me-2"></i>
              <div>{erro}</div>
            </div>
          )}

          <form onSubmit={handleSubmit}>
            {/* Usuário */}
            <div className="mb-3">
              <label htmlFor="usuario" className="form-label fw-semibold">
                <i className="fas fa-user me-2 text-muted"></i>
                Usuário
              </label>
              <input
                type="text"
                className="form-control form-control-lg"
                id="usuario"
                value={usuario}
                onChange={(e) => setUsuario(e.target.value)}
                placeholder="Digite seu usuário"
                required
                disabled={loading}
                autoFocus
                autoComplete="username"
              />
            </div>

            {/* Senha */}
            <div className="mb-4">
              <label htmlFor="senha" className="form-label fw-semibold">
                <i className="fas fa-lock me-2 text-muted"></i>
                Senha
              </label>
              <div className="input-group">
                <input
                  type={mostrarSenha ? 'text' : 'password'}
                  className="form-control form-control-lg"
                  id="senha"
                  value={senha}
                  onChange={(e) => setSenha(e.target.value)}
                  placeholder="Digite sua senha"
                  required
                  disabled={loading}
                  autoComplete="current-password"
                />
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={() => setMostrarSenha(!mostrarSenha)}
                  tabIndex={-1}
                >
                  <i className={`fas fa-eye${mostrarSenha ? '-slash' : ''}`}></i>
                </button>
              </div>
            </div>

            {/* Botão de login */}
            <button
              type="submit"
              className="btn btn-lg w-100"
              disabled={loading || !usuario.trim() || !senha.trim()}
              style={{
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                border: 'none',
                color: 'white'
              }}
            >
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2"></span>
                  Entrando...
                </>
              ) : (
                <>
                  <i className="fas fa-sign-in-alt me-2"></i>
                  Entrar
                </>
              )}
            </button>
          </form>
        </div>

        {/* Footer */}
        <div className="card-footer bg-light text-center py-3">
          <small className="text-muted">
            <i className="fas fa-lock me-1"></i>
            Área protegida e monitorada
          </small>
        </div>
      </div>
    </div>
  );
}

export default LoginAdmin;
